import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=d490a35a&"
import script from "./EventListItem.vue?vue&type=script&lang=js&"
export * from "./EventListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports